import createCustomElementWrapper from './utils/createCustomElementWrapper';
export var KatToastGroup = createCustomElementWrapper('kat-toast-group', 'KatToastGroup', {}, {
    'onCtaClicked': 'ctaClicked',
    'onToastClosed': 'toastClosed',
    'onToastOpened': 'toastOpened',
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/@amzn/katal-react/es/toast-group.js
// module id = 1282
// module chunks = 0